// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Indexes_Editbox__vdvxG {
    border: 1px solid #d2d0d0;
    background-color: #fff;
}
.Indexes_Card1__IJXba {
  border: 1px solid #c1f1f7;
}

.Indexes_BreakWhite__wlbqY {
  border-top: 1px solid #fff;
}

.Indexes_TopCard__GbPsP {
    border: 1px solid #fff;   
    color: rgb(140, 111, 25, 99%);
    background-color: #fff;
 }

.Indexes_TopCard__GbPsP i {
    color: rgba(209, 174, 68, 0.99);
    font-size: .7rem;
}

.Indexes_TopCard2__T\\+qBD {
    min-height: 30px;
    color: #747686;
    overflow: hidden;
}

.Indexes_Card__\\+A2Ue {
    border: 1px solid #1ea7ae;
}

.Indexes_Top__iqhwe {
   background-color: #1ea7ae;
   background-color: #0095a3;
   color: #fff;
}

.Indexes_TopSeries__Pzo1Q {
    background-color: #0095a3;
    /* background-color: #316a7f; */
    color: #fff;
    border: 1px solid #fff;
  }
  
  .Indexes_TopSeries__Pzo1Q i {
    color: #fff;
  }

  .Indexes_TopSeries__Pzo1Q h5 {
    color: #fff;
  }
  
  .Indexes_TopSeries__Pzo1Q:hover {
    background-color: #062b2f;
    color: #000;
  }

.Indexes_BackStatus__6tuIQ {
  border: 1px solid #fff;
  border-radius: 25px;
}

.Indexes_Border3__7R4rW i {
  font-size: .75rem;
  color: #999;
}

.Indexes_Role__UO-2i {
  color: #494d70;
}

.Indexes_Titlelist__O5WLj {
  color: #fff;
}

.Indexes_NewM__G4viI {
  background-color: #03c6f1;
  color: #fff;
  cursor: pointer;
}

.Indexes_NewM__G4viI:hover {
  background-color: #047791;
}

.Indexes_StartedM__EBmKM {
  background-color: #7103e7;
  color: #fff;
  cursor: pointer;
}

.Indexes_StartedM__EBmKM:hover {
  background-color: #4e03a0;
}

.Indexes_DoneM__bcZ\\+b {
  background-color: #04d088;
  color: #fff;
  cursor: pointer;
}

.Indexes_DoneM__bcZ\\+b:hover {
  background-color: #039260;
}

.Indexes_CancelledM__CYkg0 {
  background-color: #dc2626;
  color: #fff;
  cursor: pointer;
}

.Indexes_CancelledM__CYkg0:hover {
  background-color: #991b1b;
}

.Indexes_StatsNew__3Vh89 {
  color: #067fca;
  font-weight: 700;
}

.Indexes_StatsStart__rAHLY {
  color: #5a17a2;
  font-weight: 700;
}

.Indexes_StatsDone__pX71T {
  color: #046342;
  font-weight: 700;
}

.Indexes_StatsCancelled__SF6SO {
  color: #b91c1c;
  font-weight: 700;
}

.Indexes_New__id\\+Vx {
  background-color: #03c6f1;
  color: #fff;
  border-bottom: 1px solid #c1f1f7;
  cursor: pointer;
}

.Indexes_New__id\\+Vx:hover {
  background-color: #0383a0;
}

.Indexes_Started__-pqnx {
  background-color: #7103e7;
  color: #fff;
  border-bottom: 1px solid #c1f1f7;
  cursor: pointer;
}

.Indexes_Started__-pqnx:hover {
  background-color: #5103a5;
}

.Indexes_Done__oofyP {
  background-color: #04d088;
  color: #fff;
  border-bottom: 1px solid #c1f1f7;
  cursor: pointer;
}

.Indexes_Done__oofyP:hover {
  background-color: #03905e;
}

.Indexes_Cancelled__01eaA {
  background-color: #dc2626;
  color: #fff;
  border-bottom: 1px solid #c1f1f7;
  cursor: pointer;
}

.Indexes_Cancelled__01eaA:hover {
  background-color: #991b1b;
}

.Indexes_BottomScene__lW9gx {
  border-bottom: 2px solid #708386;
}

.Indexes_HrSched__d\\+Dml {
  border-top: 2px solid #fff;
}

.Indexes_TrackBox__jCtHi {
  border: 1px solid #999;
}

.Indexes_Border2__FJHI0 {
  border-bottom: 3px solid #c1f1f7;
  min-height: 34px;
}

.Indexes_Border3__7R4rW {
  border-bottom: 3px solid #c1f1f7;
  min-height: 34px;
}

.Indexes_Border2M__0UBFG {
  min-height: 34px;
}

.Indexes_Border3M__UsrJR {
  min-height: 34px;
}

.Indexes_CastCall__DAyIP {
  border-bottom: 3px solid #c1f1f7;
}

.Indexes_GuideText__yPniU {
  font-style: italic;
  color: #24a7b8;
}

.Indexes_Div30AD__Hg4R1 {
    color: #0183a0;
  }

.Indexes_Div30A__YWKgG {
    color: #0183a0;
    font-size: .8rem;
  }

.Indexes_Div30M__rlAoB {
    color: #00d1ff;
    color: #0183a0;
    font-size: .60rem;
  }

.Indexes_TitleBox__ONThU {
  background-color: #e8f0f1;
  background-color: #d9ecee;
}

.Indexes_TitleBox2__ptebj {
  border-right : 2px solid #fff;
  color: #000;
}

.Indexes_TitleBox2__ptebj i {
  color: #000;
}

.Indexes_Para2__fbCn3 {
  font-size: .75rem !important;
  color: #1da3aa;
  font-style: italic;
}

.Indexes_Para3Sh__jcOy4 {
  font-size: .75rem !important;
  font-weight: 600;
  color: #0b343f;
  font-style: italic;
}

.Indexes_Para2Sh__VrjJQ {
  font-size: .75rem !important;
  color: #0b343f;
  color: #1da3aa;
  font-style: italic;
}

.Indexes_Para3__Kfw4K {
  font-size: .75rem !important;
  font-weight: 600;
  color: #1da3aa;
  font-style: italic;
}

.Indexes_WhiteForm__tPYN- {
  background-color: #fff;
  border-left: 1px solid rgba(129, 102, 21, 0.99);
  border-right: 1px solid rgba(129, 102, 21, 0.99);
  border-bottom: 1px solid rgba(129, 102, 21, 0.99);
  border-top: 1px solid rgba(129, 102, 21, 0.99);
}

.Indexes_Close__RuaFw {
  color: rgb(32, 201, 201);
  padding-right: 5px;
  cursor: pointer;
  font-size: .75rem;
}

.Indexes_Close__RuaFw:hover {
  color: rgb(10, 66, 66);
}

.Indexes_Noback__kkjXk {
  color: #1ea7ae;
  font-size: .8rem;
}

.Indexes_Drop__uoaCN i {
 font-size: .7rem; 
}

.Indexes_Small__lkOZg {
  font-size: .7rem;
}

.Indexes_BreakTitle__xEXdy {
  border-top: 10px solid #e8f0f1;
}

.Indexes_BreakTitle2__YXuyh {
  border-top: 1px solid #e8f0f1;
}

.Indexes_FullsizeText__-E-09 {
  color: rgb(140, 111, 25, 99%);
  font-style: italic;
  font-size: .70rem;
}

.Indexes_FullsizeText__-E-09:hover {
  color: rgb(14, 66, 66);
  cursor: pointer;
}

.Indexes_GoldP__SLJfJ {
    color: rgb(140, 111, 25, 99%);
}

.Indexes_Break1__Q9s6a {
    border-top: 1px solid #d0d9db;
  }
  
.Indexes_Break2__rk50z {
border-top: 5px solid #d0d9db;
}

.Indexes_Width90__J73bf {
    width: 90%;
}

.Indexes_Width100__MKcAY {
    width: 100%;
}

.Indexes_Title__\\+CFhz {
    color: rgb(140, 111, 25, 99%);
    font-style: italic;
    font-weight: 700;
}

.Indexes_golddark__tkKdo {
    font-weight: 700;
    color: rgb(140, 111, 25, 99%);
  }

.Indexes_Italic__Xljuf {
    font-style: italic;
}

.Indexes_DivSize__k9VIc {
    height: 100px;
    overflow: auto;
    background-color: #fff;
}

.Indexes_White__EsBVx {
  background-color: #fff;
}

  /* .TopSeries:hover h5 {
    color: #000;
  }
  
  .TopSeries:hover i {
    color: #000;
  } */
      
.Indexes_Titledetail__dXeuP {
font-weight: 700;
color: #000;
}

.Indexes_Bottom__uG0bv:hover {
background-color: #112533;
color: #fff;
}

.Indexes_Bottom__uG0bv:hover .Indexes_Titledetail__dXeuP {
color: #fff;
}

.Indexes_Content__bDM0U {
    color: rgb(140, 111, 25, 99%);
    background-color: #fff;
}

.Indexes_Images__W1TuD {
    object-fit: contain;
    width: 100%;
}

.Indexes_ImageFull__3VcdE {
    object-fit: contain;
    width: 100%;
}

.Indexes_ImagesIndex__jgYeX {
    object-fit: contain;
    height: 235px;
    width: 100%; 
}

.Indexes_ImagesIndex__jgYeX {
    object-fit: contain; 
    height: 235px;
    width: 100%;
    border-radius: 20px; 
    padding-bottom: 0px;
    padding-top: 4px;
}

.Indexes_iframe__FZiQJ {
    pointer-events: auto;
    object-fit: contain; 
    height: 235px;
    width: 90%;
    border-radius: 2px; 
    padding-top: 4px;
    border: 1px solid #fff;
}

.Indexes_ImagesFull__lFEW7 {
    object-fit: contain;
    height: 500px;
    width: 100%;
}

.Indexes_Header__ElRZZ {
    background-color: #fff;
  }

.Indexes_Back__zxFTN {
background-color: #fff;
border-bottom: 3px solid #cfcfcf;
}

.Indexes_TrackBold__7zCag {
font-weight: 700;
border-bottom: #747686;
}

.Indexes_BoldTrack__EEMwl {
font-weight: 700;
}

.Indexes_SubTitle__7rDBq {
background-color: #e8f0f1;
font-weight: 700;
}

.Indexes_SubTitle2__SMifq {
background-color: #d6fcff;;
font-weight: 700;
}

.Indexes_SubTitle3__k0Xhd {
background-color: #e4f2f4;
font-weight: 700;
}

.Indexes_Width__NNRHA {
width: 70%;
}

.Indexes_Width2__QrdEg {
width: 80%;
}

.Indexes_Width3__tJcQ9 {
width: 80%;
}

.Indexes_Width100__MKcAY {
    width: 100%;
}

.Indexes_BoldSceneLight__6GAG- {
    color: rgb(140, 111, 25, 99%);
}

.Indexes_BoldScene__lLsFO {
  color: rgba(129, 102, 21, 0.99);
  font-weight: 600;
}

.Indexes_InputD__o9vCQ {
background: #ffffff;
border-bottom: 1px #00d1ff solid;
border-top: 1px solid #fff;
border-right: 1px solid #fff;
border-left: 1px solid #fff;
box-sizing: border-box;
border-radius: 2px;
color: #747686;
padding: 0px 10px;
height: 30px !important;
text-align: center;
}

.Indexes_Input__O8Aju {
background: #ffffff;
border-bottom: 1px #00d1ff solid;
border-top: 1px solid #fff;
border-right: 1px solid #fff;
border-left: 1px solid #fff;
box-sizing: border-box;
border-radius: 2px;
color: #747686;
padding: 0px 10px;
height: 30px !important;
text-align: center;
}

.Indexes_InputEx__lO5sq {
  background: #ffffff;
  border-bottom: 1px #00d1ff solid;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  border-left: 1px solid #fff;
  box-sizing: border-box;
  border-radius: 2px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  height: 30px !important;
  text-align: center;
  color: #3d3d3e;
}

.Indexes_InputScene__e1\\+8D {
background: #ffffff;
border-bottom: 1px #00d1ff solid;
border-top: 1px solid #fff;
border-right: 1px solid #fff;
border-left: 1px solid #fff;
box-sizing: border-box;
border-radius: 2px;
color: #747686;
padding: 0px 10px;
text-align: center;
}

.Indexes_InputBar__nr-Mv {
background: #ffffff;
border: 1px solid #c1f1f7;
box-sizing: border-box;
border-radius: 25px;
color: #747686;
padding: 0px 10px;
height: 30px !important;
/* text-align: center; */
}

.Indexes_InputBarShot__c3RsM {
background: #ffffff;
border: 1px solid #c1f1f7;
box-sizing: border-box;
border-radius: 25px;
color: #747686;
padding: 0px 10px;
height: 30px !important;
/* text-align: center; */
}

.Indexes_InputChar__Ay4k6 {
background: #ffffff;
border: 1px solid #f0f1f9;
box-sizing: border-box;
border-radius: 8px;
color: #747686;
padding: 0px 0px;
height: 30px !important;
text-align: center;
}

.Indexes_BoldTitle__JdkI7 {
font-weight: 700;
background-color: rgb(209, 240, 240);
}

@media screen and (min-width: 1800px) {
  .Indexes_ImagesIndex__jgYeX {
  height: 500px;
  }

  .Indexes_iframe__FZiQJ {
  height: 500px;
  }
}

@media screen and (max-width: 780px) {
.Indexes_Width3__tJcQ9 {
    width: 50%;
}

.Indexes_Border3M__UsrJR i {
  font-size: .75rem;
  color: #0183a0;
}
}

@media screen and (max-width: 600px) {
  .Indexes_Titlelist__O5WLj {
    font-size: 1rem ;
  }

  .Indexes_Icon__u\\+JAG i {
    font-size: 1rem;
  }
  
.Indexes_BoldScene__lLsFO {
    font-size: .75rem;
}

.Indexes_Input__O8Aju {
height: 20px !important;
text-align: center;
font-size: .75rem !important;
}

.Indexes_InputBar__nr-Mv {
    height: 20px !important;
    font-size: .75rem !important;
}

.Indexes_InputBarShot__c3RsM {
    height: 20px !important;
    font-size: .75rem !important;
}

.Indexes_InputScene__e1\\+8D {
font-size: .75rem !important;
}

.Indexes_Width__NNRHA {
    width: 90%;
}

.Indexes_Width2__QrdEg {
    width: 90%;
}

.Indexes_Width95__1prlF {
    width: 100%;
}

h1 {
    font-size: 1.75rem;
}

h2 {
    font-size: 1.5rem;
}

}

@media screen and (max-width: 335px) {
.Indexes_BoldTrack__EEMwl {
font-weight: 700;
font-size: .9rem;
}
}
`, "",{"version":3,"sources":["webpack://./src/styles/Indexes.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;CACzB;;AAED;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;GACG,yBAAyB;GACzB,yBAAyB;GACzB,WAAW;AACd;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;AAEF;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;IACI,cAAc;EAChB;;AAEF;IACI,cAAc;IACd,gBAAgB;EAClB;;AAEF;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;EACnB;;AAEF;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,+CAA+C;EAC/C,gDAAgD;EAChD,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;EAC/B;;AAEF;AACA,6BAA6B;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;EAC/B;;AAEF;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;EAEE;;;;;;KAMG;;AAEL;AACA,gBAAgB;AAChB,WAAW;AACX;;AAEA;AACA,yBAAyB;AACzB,WAAW;AACX;;AAEA;AACA,WAAW;AACX;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,sBAAsB;EACxB;;AAEF;AACA,sBAAsB;AACtB,gCAAgC;AAChC;;AAEA;AACA,gBAAgB;AAChB,sBAAsB;AACtB;;AAEA;AACA,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB,gBAAgB;AAChB;;AAEA;AACA,UAAU;AACV;;AAEA;AACA,UAAU;AACV;;AAEA;AACA,UAAU;AACV;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;AACA,mBAAmB;AACnB,gCAAgC;AAChC,0BAA0B;AAC1B,4BAA4B;AAC5B,2BAA2B;AAC3B,sBAAsB;AACtB,kBAAkB;AAClB,cAAc;AACd,iBAAiB;AACjB,uBAAuB;AACvB,kBAAkB;AAClB;;AAEA;AACA,mBAAmB;AACnB,gCAAgC;AAChC,0BAA0B;AAC1B,4BAA4B;AAC5B,2BAA2B;AAC3B,sBAAsB;AACtB,kBAAkB;AAClB,cAAc;AACd,iBAAiB;AACjB,uBAAuB;AACvB,kBAAkB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;AACA,mBAAmB;AACnB,gCAAgC;AAChC,0BAA0B;AAC1B,4BAA4B;AAC5B,2BAA2B;AAC3B,sBAAsB;AACtB,kBAAkB;AAClB,cAAc;AACd,iBAAiB;AACjB,kBAAkB;AAClB;;AAEA;AACA,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,mBAAmB;AACnB,cAAc;AACd,iBAAiB;AACjB,uBAAuB;AACvB,wBAAwB;AACxB;;AAEA;AACA,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,mBAAmB;AACnB,cAAc;AACd,iBAAiB;AACjB,uBAAuB;AACvB,wBAAwB;AACxB;;AAEA;AACA,mBAAmB;AACnB,yBAAyB;AACzB,sBAAsB;AACtB,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,uBAAuB;AACvB,kBAAkB;AAClB;;AAEA;AACA,gBAAgB;AAChB,oCAAoC;AACpC;;AAEA;EACE;EACA,aAAa;EACb;;EAEA;EACA,aAAa;EACb;AACF;;AAEA;AACA;IACI,UAAU;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;AAEF;IACI,iBAAiB;AACrB;;AAEA;AACA,uBAAuB;AACvB,kBAAkB;AAClB,4BAA4B;AAC5B;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;AACA,4BAA4B;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;AAEA;AACA;AACA,gBAAgB;AAChB,gBAAgB;AAChB;AACA","sourcesContent":[".Editbox {\n    border: 1px solid #d2d0d0;\n    background-color: #fff;\n}\n.Card1 {\n  border: 1px solid #c1f1f7;\n}\n\n.BreakWhite {\n  border-top: 1px solid #fff;\n}\n\n.TopCard {\n    border: 1px solid #fff;   \n    color: rgb(140, 111, 25, 99%);\n    background-color: #fff;\n }\n\n.TopCard i {\n    color: rgba(209, 174, 68, 0.99);\n    font-size: .7rem;\n}\n\n.TopCard2 {\n    min-height: 30px;\n    color: #747686;\n    overflow: hidden;\n}\n\n.Card {\n    border: 1px solid #1ea7ae;\n}\n\n.Top {\n   background-color: #1ea7ae;\n   background-color: #0095a3;\n   color: #fff;\n}\n\n.TopSeries {\n    background-color: #0095a3;\n    /* background-color: #316a7f; */\n    color: #fff;\n    border: 1px solid #fff;\n  }\n  \n  .TopSeries i {\n    color: #fff;\n  }\n\n  .TopSeries h5 {\n    color: #fff;\n  }\n  \n  .TopSeries:hover {\n    background-color: #062b2f;\n    color: #000;\n  }\n\n.BackStatus {\n  border: 1px solid #fff;\n  border-radius: 25px;\n}\n\n.Border3 i {\n  font-size: .75rem;\n  color: #999;\n}\n\n.Role {\n  color: #494d70;\n}\n\n.Titlelist {\n  color: #fff;\n}\n\n.NewM {\n  background-color: #03c6f1;\n  color: #fff;\n  cursor: pointer;\n}\n\n.NewM:hover {\n  background-color: #047791;\n}\n\n.StartedM {\n  background-color: #7103e7;\n  color: #fff;\n  cursor: pointer;\n}\n\n.StartedM:hover {\n  background-color: #4e03a0;\n}\n\n.DoneM {\n  background-color: #04d088;\n  color: #fff;\n  cursor: pointer;\n}\n\n.DoneM:hover {\n  background-color: #039260;\n}\n\n.CancelledM {\n  background-color: #dc2626;\n  color: #fff;\n  cursor: pointer;\n}\n\n.CancelledM:hover {\n  background-color: #991b1b;\n}\n\n.StatsNew {\n  color: #067fca;\n  font-weight: 700;\n}\n\n.StatsStart {\n  color: #5a17a2;\n  font-weight: 700;\n}\n\n.StatsDone {\n  color: #046342;\n  font-weight: 700;\n}\n\n.StatsCancelled {\n  color: #b91c1c;\n  font-weight: 700;\n}\n\n.New {\n  background-color: #03c6f1;\n  color: #fff;\n  border-bottom: 1px solid #c1f1f7;\n  cursor: pointer;\n}\n\n.New:hover {\n  background-color: #0383a0;\n}\n\n.Started {\n  background-color: #7103e7;\n  color: #fff;\n  border-bottom: 1px solid #c1f1f7;\n  cursor: pointer;\n}\n\n.Started:hover {\n  background-color: #5103a5;\n}\n\n.Done {\n  background-color: #04d088;\n  color: #fff;\n  border-bottom: 1px solid #c1f1f7;\n  cursor: pointer;\n}\n\n.Done:hover {\n  background-color: #03905e;\n}\n\n.Cancelled {\n  background-color: #dc2626;\n  color: #fff;\n  border-bottom: 1px solid #c1f1f7;\n  cursor: pointer;\n}\n\n.Cancelled:hover {\n  background-color: #991b1b;\n}\n\n.BottomScene {\n  border-bottom: 2px solid #708386;\n}\n\n.HrSched {\n  border-top: 2px solid #fff;\n}\n\n.TrackBox {\n  border: 1px solid #999;\n}\n\n.Border2 {\n  border-bottom: 3px solid #c1f1f7;\n  min-height: 34px;\n}\n\n.Border3 {\n  border-bottom: 3px solid #c1f1f7;\n  min-height: 34px;\n}\n\n.Border2M {\n  min-height: 34px;\n}\n\n.Border3M {\n  min-height: 34px;\n}\n\n.CastCall {\n  border-bottom: 3px solid #c1f1f7;\n}\n\n.GuideText {\n  font-style: italic;\n  color: #24a7b8;\n}\n\n.Div30AD {\n    color: #0183a0;\n  }\n\n.Div30A {\n    color: #0183a0;\n    font-size: .8rem;\n  }\n\n.Div30M {\n    color: #00d1ff;\n    color: #0183a0;\n    font-size: .60rem;\n  }\n\n.TitleBox {\n  background-color: #e8f0f1;\n  background-color: #d9ecee;\n}\n\n.TitleBox2 {\n  border-right : 2px solid #fff;\n  color: #000;\n}\n\n.TitleBox2 i {\n  color: #000;\n}\n\n.Para2 {\n  font-size: .75rem !important;\n  color: #1da3aa;\n  font-style: italic;\n}\n\n.Para3Sh {\n  font-size: .75rem !important;\n  font-weight: 600;\n  color: #0b343f;\n  font-style: italic;\n}\n\n.Para2Sh {\n  font-size: .75rem !important;\n  color: #0b343f;\n  color: #1da3aa;\n  font-style: italic;\n}\n\n.Para3 {\n  font-size: .75rem !important;\n  font-weight: 600;\n  color: #1da3aa;\n  font-style: italic;\n}\n\n.WhiteForm {\n  background-color: #fff;\n  border-left: 1px solid rgba(129, 102, 21, 0.99);\n  border-right: 1px solid rgba(129, 102, 21, 0.99);\n  border-bottom: 1px solid rgba(129, 102, 21, 0.99);\n  border-top: 1px solid rgba(129, 102, 21, 0.99);\n}\n\n.Close {\n  color: rgb(32, 201, 201);\n  padding-right: 5px;\n  cursor: pointer;\n  font-size: .75rem;\n}\n\n.Close:hover {\n  color: rgb(10, 66, 66);\n}\n\n.Noback {\n  color: #1ea7ae;\n  font-size: .8rem;\n}\n\n.Drop i {\n font-size: .7rem; \n}\n\n.Small {\n  font-size: .7rem;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.BreakTitle2 {\n  border-top: 1px solid #e8f0f1;\n}\n\n.FullsizeText {\n  color: rgb(140, 111, 25, 99%);\n  font-style: italic;\n  font-size: .70rem;\n}\n\n.FullsizeText:hover {\n  color: rgb(14, 66, 66);\n  cursor: pointer;\n}\n\n.GoldP {\n    color: rgb(140, 111, 25, 99%);\n}\n\n.Break1 {\n    border-top: 1px solid #d0d9db;\n  }\n  \n.Break2 {\nborder-top: 5px solid #d0d9db;\n}\n\n.Width90 {\n    width: 90%;\n}\n\n.Width100 {\n    width: 100%;\n}\n\n.Title {\n    color: rgb(140, 111, 25, 99%);\n    font-style: italic;\n    font-weight: 700;\n}\n\n.golddark {\n    font-weight: 700;\n    color: rgb(140, 111, 25, 99%);\n  }\n\n.Italic {\n    font-style: italic;\n}\n\n.DivSize {\n    height: 100px;\n    overflow: auto;\n    background-color: #fff;\n}\n\n.White {\n  background-color: #fff;\n}\n\n  /* .TopSeries:hover h5 {\n    color: #000;\n  }\n  \n  .TopSeries:hover i {\n    color: #000;\n  } */\n      \n.Titledetail {\nfont-weight: 700;\ncolor: #000;\n}\n\n.Bottom:hover {\nbackground-color: #112533;\ncolor: #fff;\n}\n\n.Bottom:hover .Titledetail {\ncolor: #fff;\n}\n\n.Content {\n    color: rgb(140, 111, 25, 99%);\n    background-color: #fff;\n}\n\n.Images {\n    object-fit: contain;\n    width: 100%;\n}\n\n.ImageFull {\n    object-fit: contain;\n    width: 100%;\n}\n\n.ImagesIndex {\n    object-fit: contain;\n    height: 235px;\n    width: 100%; \n}\n\n.ImagesIndex {\n    object-fit: contain; \n    height: 235px;\n    width: 100%;\n    border-radius: 20px; \n    padding-bottom: 0px;\n    padding-top: 4px;\n}\n\n.iframe {\n    pointer-events: auto;\n    object-fit: contain; \n    height: 235px;\n    width: 90%;\n    border-radius: 2px; \n    padding-top: 4px;\n    border: 1px solid #fff;\n}\n\n.ImagesFull {\n    object-fit: contain;\n    height: 500px;\n    width: 100%;\n}\n\n.Header {\n    background-color: #fff;\n  }\n\n.Back {\nbackground-color: #fff;\nborder-bottom: 3px solid #cfcfcf;\n}\n\n.TrackBold {\nfont-weight: 700;\nborder-bottom: #747686;\n}\n\n.BoldTrack {\nfont-weight: 700;\n}\n\n.SubTitle {\nbackground-color: #e8f0f1;\nfont-weight: 700;\n}\n\n.SubTitle2 {\nbackground-color: #d6fcff;;\nfont-weight: 700;\n}\n\n.SubTitle3 {\nbackground-color: #e4f2f4;\nfont-weight: 700;\n}\n\n.Width {\nwidth: 70%;\n}\n\n.Width2 {\nwidth: 80%;\n}\n\n.Width3 {\nwidth: 80%;\n}\n\n.Width100 {\n    width: 100%;\n}\n\n.BoldSceneLight {\n    color: rgb(140, 111, 25, 99%);\n}\n\n.BoldScene {\n  color: rgba(129, 102, 21, 0.99);\n  font-weight: 600;\n}\n\n.InputD {\nbackground: #ffffff;\nborder-bottom: 1px #00d1ff solid;\nborder-top: 1px solid #fff;\nborder-right: 1px solid #fff;\nborder-left: 1px solid #fff;\nbox-sizing: border-box;\nborder-radius: 2px;\ncolor: #747686;\npadding: 0px 10px;\nheight: 30px !important;\ntext-align: center;\n}\n\n.Input {\nbackground: #ffffff;\nborder-bottom: 1px #00d1ff solid;\nborder-top: 1px solid #fff;\nborder-right: 1px solid #fff;\nborder-left: 1px solid #fff;\nbox-sizing: border-box;\nborder-radius: 2px;\ncolor: #747686;\npadding: 0px 10px;\nheight: 30px !important;\ntext-align: center;\n}\n\n.InputEx {\n  background: #ffffff;\n  border-bottom: 1px #00d1ff solid;\n  border-top: 1px solid #fff;\n  border-right: 1px solid #fff;\n  border-left: 1px solid #fff;\n  box-sizing: border-box;\n  border-radius: 2px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-left: 0px;\n  height: 30px !important;\n  text-align: center;\n  color: #3d3d3e;\n}\n\n.InputScene {\nbackground: #ffffff;\nborder-bottom: 1px #00d1ff solid;\nborder-top: 1px solid #fff;\nborder-right: 1px solid #fff;\nborder-left: 1px solid #fff;\nbox-sizing: border-box;\nborder-radius: 2px;\ncolor: #747686;\npadding: 0px 10px;\ntext-align: center;\n}\n\n.InputBar {\nbackground: #ffffff;\nborder: 1px solid #c1f1f7;\nbox-sizing: border-box;\nborder-radius: 25px;\ncolor: #747686;\npadding: 0px 10px;\nheight: 30px !important;\n/* text-align: center; */\n}\n\n.InputBarShot {\nbackground: #ffffff;\nborder: 1px solid #c1f1f7;\nbox-sizing: border-box;\nborder-radius: 25px;\ncolor: #747686;\npadding: 0px 10px;\nheight: 30px !important;\n/* text-align: center; */\n}\n\n.InputChar {\nbackground: #ffffff;\nborder: 1px solid #f0f1f9;\nbox-sizing: border-box;\nborder-radius: 8px;\ncolor: #747686;\npadding: 0px 0px;\nheight: 30px !important;\ntext-align: center;\n}\n\n.BoldTitle {\nfont-weight: 700;\nbackground-color: rgb(209, 240, 240);\n}\n\n@media screen and (min-width: 1800px) {\n  .ImagesIndex {\n  height: 500px;\n  }\n\n  .iframe {\n  height: 500px;\n  }\n}\n\n@media screen and (max-width: 780px) {\n.Width3 {\n    width: 50%;\n}\n\n.Border3M i {\n  font-size: .75rem;\n  color: #0183a0;\n}\n}\n\n@media screen and (max-width: 600px) {\n  .Titlelist {\n    font-size: 1rem ;\n  }\n\n  .Icon i {\n    font-size: 1rem;\n  }\n  \n.BoldScene {\n    font-size: .75rem;\n}\n\n.Input {\nheight: 20px !important;\ntext-align: center;\nfont-size: .75rem !important;\n}\n\n.InputBar {\n    height: 20px !important;\n    font-size: .75rem !important;\n}\n\n.InputBarShot {\n    height: 20px !important;\n    font-size: .75rem !important;\n}\n\n.InputScene {\nfont-size: .75rem !important;\n}\n\n.Width {\n    width: 90%;\n}\n\n.Width2 {\n    width: 90%;\n}\n\n.Width95 {\n    width: 100%;\n}\n\nh1 {\n    font-size: 1.75rem;\n}\n\nh2 {\n    font-size: 1.5rem;\n}\n\n}\n\n@media screen and (max-width: 335px) {\n.BoldTrack {\nfont-weight: 700;\nfont-size: .9rem;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Editbox": `Indexes_Editbox__vdvxG`,
	"Card1": `Indexes_Card1__IJXba`,
	"BreakWhite": `Indexes_BreakWhite__wlbqY`,
	"TopCard": `Indexes_TopCard__GbPsP`,
	"TopCard2": `Indexes_TopCard2__T+qBD`,
	"Card": `Indexes_Card__+A2Ue`,
	"Top": `Indexes_Top__iqhwe`,
	"TopSeries": `Indexes_TopSeries__Pzo1Q`,
	"BackStatus": `Indexes_BackStatus__6tuIQ`,
	"Border3": `Indexes_Border3__7R4rW`,
	"Role": `Indexes_Role__UO-2i`,
	"Titlelist": `Indexes_Titlelist__O5WLj`,
	"NewM": `Indexes_NewM__G4viI`,
	"StartedM": `Indexes_StartedM__EBmKM`,
	"DoneM": `Indexes_DoneM__bcZ+b`,
	"CancelledM": `Indexes_CancelledM__CYkg0`,
	"StatsNew": `Indexes_StatsNew__3Vh89`,
	"StatsStart": `Indexes_StatsStart__rAHLY`,
	"StatsDone": `Indexes_StatsDone__pX71T`,
	"StatsCancelled": `Indexes_StatsCancelled__SF6SO`,
	"New": `Indexes_New__id+Vx`,
	"Started": `Indexes_Started__-pqnx`,
	"Done": `Indexes_Done__oofyP`,
	"Cancelled": `Indexes_Cancelled__01eaA`,
	"BottomScene": `Indexes_BottomScene__lW9gx`,
	"HrSched": `Indexes_HrSched__d+Dml`,
	"TrackBox": `Indexes_TrackBox__jCtHi`,
	"Border2": `Indexes_Border2__FJHI0`,
	"Border2M": `Indexes_Border2M__0UBFG`,
	"Border3M": `Indexes_Border3M__UsrJR`,
	"CastCall": `Indexes_CastCall__DAyIP`,
	"GuideText": `Indexes_GuideText__yPniU`,
	"Div30AD": `Indexes_Div30AD__Hg4R1`,
	"Div30A": `Indexes_Div30A__YWKgG`,
	"Div30M": `Indexes_Div30M__rlAoB`,
	"TitleBox": `Indexes_TitleBox__ONThU`,
	"TitleBox2": `Indexes_TitleBox2__ptebj`,
	"Para2": `Indexes_Para2__fbCn3`,
	"Para3Sh": `Indexes_Para3Sh__jcOy4`,
	"Para2Sh": `Indexes_Para2Sh__VrjJQ`,
	"Para3": `Indexes_Para3__Kfw4K`,
	"WhiteForm": `Indexes_WhiteForm__tPYN-`,
	"Close": `Indexes_Close__RuaFw`,
	"Noback": `Indexes_Noback__kkjXk`,
	"Drop": `Indexes_Drop__uoaCN`,
	"Small": `Indexes_Small__lkOZg`,
	"BreakTitle": `Indexes_BreakTitle__xEXdy`,
	"BreakTitle2": `Indexes_BreakTitle2__YXuyh`,
	"FullsizeText": `Indexes_FullsizeText__-E-09`,
	"GoldP": `Indexes_GoldP__SLJfJ`,
	"Break1": `Indexes_Break1__Q9s6a`,
	"Break2": `Indexes_Break2__rk50z`,
	"Width90": `Indexes_Width90__J73bf`,
	"Width100": `Indexes_Width100__MKcAY`,
	"Title": `Indexes_Title__+CFhz`,
	"golddark": `Indexes_golddark__tkKdo`,
	"Italic": `Indexes_Italic__Xljuf`,
	"DivSize": `Indexes_DivSize__k9VIc`,
	"White": `Indexes_White__EsBVx`,
	"Titledetail": `Indexes_Titledetail__dXeuP`,
	"Bottom": `Indexes_Bottom__uG0bv`,
	"Content": `Indexes_Content__bDM0U`,
	"Images": `Indexes_Images__W1TuD`,
	"ImageFull": `Indexes_ImageFull__3VcdE`,
	"ImagesIndex": `Indexes_ImagesIndex__jgYeX`,
	"iframe": `Indexes_iframe__FZiQJ`,
	"ImagesFull": `Indexes_ImagesFull__lFEW7`,
	"Header": `Indexes_Header__ElRZZ`,
	"Back": `Indexes_Back__zxFTN`,
	"TrackBold": `Indexes_TrackBold__7zCag`,
	"BoldTrack": `Indexes_BoldTrack__EEMwl`,
	"SubTitle": `Indexes_SubTitle__7rDBq`,
	"SubTitle2": `Indexes_SubTitle2__SMifq`,
	"SubTitle3": `Indexes_SubTitle3__k0Xhd`,
	"Width": `Indexes_Width__NNRHA`,
	"Width2": `Indexes_Width2__QrdEg`,
	"Width3": `Indexes_Width3__tJcQ9`,
	"BoldSceneLight": `Indexes_BoldSceneLight__6GAG-`,
	"BoldScene": `Indexes_BoldScene__lLsFO`,
	"InputD": `Indexes_InputD__o9vCQ`,
	"Input": `Indexes_Input__O8Aju`,
	"InputEx": `Indexes_InputEx__lO5sq`,
	"InputScene": `Indexes_InputScene__e1+8D`,
	"InputBar": `Indexes_InputBar__nr-Mv`,
	"InputBarShot": `Indexes_InputBarShot__c3RsM`,
	"InputChar": `Indexes_InputChar__Ay4k6`,
	"BoldTitle": `Indexes_BoldTitle__JdkI7`,
	"Icon": `Indexes_Icon__u+JAG`,
	"Width95": `Indexes_Width95__1prlF`
};
export default ___CSS_LOADER_EXPORT___;
